<app-edit-rates
  [isCreating]="true"
  [isEditing]="true"
  [rateType]="rateType"
></app-edit-rates>
